export const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
  },
  iconWrap: {
    cursor: 'pointer',
    display: 'flex',
  },
  addButton: {
    border: '1px solid var(--color-button-secondary)',
    height: 42,
    minWidth: 42,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    cursor: 'pointer',
  },
})
